import { apiUrl } from "../../api/endpoints";
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Select from 'react-select';
import { QueryBuilder } from 'react-querybuilder';
import { useNavigate } from 'react-router-dom';
import 'react-querybuilder/dist/query-builder.css';
import '../../Pages/automations.css';
import '../../Pages/edit.css';
import '../../Pages/details.css';
import Spinner from '../../Components/Spinner';
import Alert from '../../Components/Alert';

import { useAuth } from '../../hooks/AuthProvider';
import { getErrorMessage } from '../../utils/errorUtils';
import { buildDeviceDropdownOption, getDeviceDropdownId } from '../../utils/dropdownLabels';
import { LanguageContext } from '../../context/LanguageContext';
import automationsTranslations from '../../languages/automation.json';
import { ActionsIcon, AutomationHeaderIcon, TriggerIcon } from '../../svg/AutomationIcons';
import { DeviceIcon, OrganizationIcon } from '../../Icons';
import AutomationActionsBuilder from './AutomationActionsBuilder';
import {
  applyConditionFieldTypes,
  buildAutomationPayload,
  buildTemplateFields,
  collectActionIds,
  collectConditionIds,
  createEmptyConditions,
  createInitialAutomation,
  fixedField,
  getTemplateIdFromDevice,
  statusFixedField,
  statusFixedValue,
  triggerOptions,
} from './automationHelpers';

const resolveDeviceOption = (options, automationDevice) =>
  options.find((option) => option.value === automationDevice?.did) ||
  (automationDevice?.did
    ? buildDeviceDropdownOption(
      {
        id: automationDevice?.device_id,
        did: automationDevice?.did,
        name: automationDevice?.device_name,
        organization_name: automationDevice?.organization_name,
      },
      'did'
    )
    : null);
const DATE_LIKE_CONDITION_TYPES = new Set(['date', 'datetime', 'date_time', 'datetime-local', 'time']);

const isDateLikeConditionType = (inputType) =>
  DATE_LIKE_CONDITION_TYPES.has(String(inputType || '').trim().toLowerCase());

const getDateLikeInputType = (inputType) => {
  const normalized = String(inputType || '').trim().toLowerCase();
  if (normalized === 'datetime' || normalized === 'date_time') return 'datetime-local';
  return isDateLikeConditionType(normalized) ? normalized : undefined;
};

const CustomValueEditor = React.memo(({ value, handleOnChange, fieldData, type, dynamicFields,
  templatesByDid, trigger }) => {

  const parsed =
    typeof value === 'object'
      ? value
      : { value: value ?? '', duration: 0 };
  const hideDuration = isDateLikeConditionType(fieldData?.inputType || type);
  const [conditionValueType, setConditionValueType] = useState('constant');
  const options = useMemo(() => {
    return dynamicFields.map((f) => ({
      value: f.name,
      label: f.label,
    }));
  }, [dynamicFields]);
  useEffect(() => {
    if (parsed.datastream_value) {
      setConditionValueType('datastream');
    } else {
      setConditionValueType('constant');
    }
  }, [parsed.datastream_value]);
  console.log('parsed.datastream_value : ' + parsed.datastream_value)
  return (

    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      <span style={{ whiteSpace: 'nowrap' }}>Value type</span>
      <div
        style={{
          display: 'flex',
          gap: 30,
          marginInlineStart: 10,
          alignItems: 'center',
        }}
      >
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          <input
            type='radio'
            value='constant'
            checked={conditionValueType === 'constant'}
            onChange={(event) => {
              setConditionValueType(event.target.value)
            }}
            style={{
              transform: 'scale(1.3)',
              cursor: 'pointer',
            }}
          />
          <span>Constant</span>
        </label>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          <input
            disabled={trigger !== 'datastream'}
            type='radio'
            value='datastream'
            checked={conditionValueType === 'datastream'}
            onChange={(event) => {
              setConditionValueType(event.target.value)
            }}
            style={{
              transform: 'scale(1.3)',
              cursor: 'pointer',
            }}
          />
          <span>Datastream</span>
        </label>
      </div>
      {conditionValueType === 'constant' && trigger !== 'deviceStatus' ?
        <Fragment>
          <span>Value</span>

          <input
            type={getDateLikeInputType(fieldData?.inputType)}
            className="qb-value"
            value={parsed.value}
            onChange={(e) =>
              handleOnChange({
                ...parsed,
                value: e.target.value,
                datastream_value: null,
                duration: hideDuration ? 0 : parsed.duration,
              })
            }
          /> </Fragment>
        : conditionValueType === 'constant' ? <Select
          options={statusFixedValue}
          value={statusFixedValue.find(x => x.value === parsed.value)}
          onChange={(opt) =>
            handleOnChange({
              ...parsed,
              value: opt?.value,
              datastream_value: null,
              duration: hideDuration ? 0 : parsed.duration,
            })
          }
          style={{ width: 'inherit' }}
          classNamePrefix='react-select'
        /> : <Fragment>
          <span>Value</span>
          <Select
            value={
              options.find(
                (option) => option.value === parsed.datastream_value
              ) || null
            } options={options}
            onChange={(opt) =>
              handleOnChange({
                ...parsed,
                datastream_value: opt?.value,
                value: null,
                duration: hideDuration ? 0 : parsed.duration,

              })
            }
            style={{ width: 'inherit' }}
            classNamePrefix='react-select'

          />
        </Fragment>

      }


      {hideDuration ? null : (
        <Fragment>
          <span>Duration</span>

          <input
            type="number"
            style={{ width: 90 }}
            value={parsed.duration}
            onChange={(e) =>
              handleOnChange({
                ...parsed,
                value: parsed.value,
                datastream_value: parsed.datastream_value,
                duration: Number(e.target.value || 0),
              })
            }
          />
        </Fragment>
      )}
    </div>
  );
});
const createAlertState = (isRtl) => ({
  open: false,
  message: '',
  type: 'info',
  position: isRtl ? 'left' : 'right',
});

const AutomationBuilderPage = ({ mode = 'create', automationId = null }) => {
  const isCreateMode = mode === 'create';
  const navigate = useNavigate();
  const { org, permissions } = useAuth();
  const { lang } = useContext(LanguageContext);

  const t = automationsTranslations[lang];
  const isRtl = ['ar', 'ur'].includes(lang);
  const requiredPermission = isCreateMode ? 'create_automations' : 'edit_automations';
  const hasPermission = Boolean(permissions?.[requiredPermission]);

  const [devices, setDevices] = useState([]);
  const [automation, setAutomation] = useState(createInitialAutomation(org));
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [loading, setLoading] = useState(!isCreateMode);
  const [submitting, setSubmitting] = useState(false);
  const [alertState, setAlertState] = useState(createAlertState(isRtl));
  const [deviceDetailsByDid, setDeviceDetailsByDid] = useState({});
  const [templatesByDid, setTemplatesByDid] = useState({});
  const [persistedIds, setPersistedIds] = useState({
    conditionIds: new Set(),
    actionIds: new Set(),
  });
  const [targetType, setTargetType] = useState('device');

  const [templates, setTemplates] = useState([]);
  const deviceDetailRequestsRef = useRef(new Map());
  const templateRequestsRef = useRef(new Map());

  const showAlert = useCallback((type, message) => {
    setAlertState({
      open: true,
      message,
      type,
      position: isRtl ? 'left' : 'right',
    });
  }, [isRtl]);
  const loadTemplates = useCallback(async () => {


    const response = await axios.get(
      apiUrl(`template/list`)
    );

    const nextTemplates = Array.isArray(response.data?.data)
      ? response.data.data
      : [];

    setTemplates(nextTemplates);

    return nextTemplates;
  }, []);
  const loadDevicesForOrganization = useCallback(async (organizationId) => {
    if (!organizationId) {
      setDevices([]);
      return [];
    }

    const response = await axios.get(apiUrl(`device/filtered/${organizationId}`));
    const nextDevices = Array.isArray(response.data?.data) ? response.data.data : [];
    setDevices(nextDevices);
    return nextDevices;
  }, []);

  const ensureDeviceDetail = useCallback(async (did) => {
    if (!did) {
      return null;
    }

    if (deviceDetailsByDid[did]) {
      return deviceDetailsByDid[did];
    }

    if (deviceDetailRequestsRef.current.has(did)) {
      return deviceDetailRequestsRef.current.get(did);
    }

    const request = axios
      .get(apiUrl(`device/get-did/${did}`))
      .then((response) => {
        const deviceData = response.data?.data ?? null;
        if (deviceData) {
          setDeviceDetailsByDid((current) => ({ ...current, [did]: deviceData }));
        }
        return deviceData;
      })
      .finally(() => {
        deviceDetailRequestsRef.current.delete(did);
      });

    deviceDetailRequestsRef.current.set(did, request);
    return request;
  }, [deviceDetailsByDid]);

  const ensureTemplate = useCallback(async (did) => {
    if (!did) {
      return null;
    }

    if (Object.prototype.hasOwnProperty.call(templatesByDid, did)) {
      return templatesByDid[did];
    }

    if (templateRequestsRef.current.has(did)) {
      return templateRequestsRef.current.get(did);
    }
    const request = (async () => {
      console.log('kpppppppppppppppppp')
      const deviceData = await ensureDeviceDetail(did);
      const templateId = getTemplateIdFromDevice(deviceData);
      if (!templateId) {
        setTemplatesByDid((current) => ({ ...current, [did]: null }));
        return null;
      }

      const response = await axios.get(apiUrl(`template/get/${templateId}`));
      const templateData = response.data?.data ?? null;
      setTemplatesByDid((current) => ({ ...current, [did]: templateData }));
      return templateData;
    })().finally(() => {
      templateRequestsRef.current.delete(did);
    });

    templateRequestsRef.current.set(did, request);
    return request;
  }, [ensureDeviceDetail, templatesByDid]);

  useEffect(() => {
    setAlertState(createAlertState(isRtl));
  }, [isRtl]);

  useEffect(() => {
    if (!isCreateMode) {
      return;
    }

    setAutomation((current) => ({
      ...current,
      organization_id: org?.id ?? null,
      organization_name: org?.name ?? null,
    }));
  }, [isCreateMode, org?.id, org?.name]);

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    let isCancelled = false;

    const loadPageData = async () => {
      setLoading(true);

      try {
        await loadTemplates();

        if (isCreateMode) {
          await loadDevicesForOrganization(org?.id);
          return;
        }
        const automationResponse = await axios.get(apiUrl(`automation/${automationId}`));
        const fetchedAutomation = automationResponse.data?.data;
        setTargetType(fetchedAutomation?.did ? 'device' : 'template')
        if (!fetchedAutomation || isCancelled) {
          return;
        }

        setAutomation({
          ...fetchedAutomation,
          conditions: hydrateConditions(fetchedAutomation.conditions),
        });
        setPersistedIds({
          conditionIds: collectConditionIds(fetchedAutomation.conditions),
          actionIds: collectActionIds(fetchedAutomation.actions),
        });

        await loadDevicesForOrganization(fetchedAutomation.organization_id);
      } catch (error) {
        if (isCancelled) {
          return;
        }

        const errorMessage = getErrorMessage(error);
        showAlert('error', errorMessage);

        if (!isCreateMode && error.response?.status === 404) {
          setTimeout(() => navigate('/automations'), 3000);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    loadPageData();

    return () => {
      isCancelled = true;
    };
  }, [automationId, hasPermission, isCreateMode, loadDevicesForOrganization, navigate, org?.id, showAlert]);

  useEffect(() => {
    const fetchData = async () => {
      const didsToResolve = new Set([
        automation?.did,
        ...(Array.isArray(automation?.actions)
          ? automation.actions.map((action) => action?.did)
          : []),
      ].filter(Boolean));

      didsToResolve.forEach((did) => {
        ensureTemplate(did).catch((error) => {
          console.error(`Failed to load template for device DID ${did}:`, error);
        });
      });

    };

    fetchData();
  }, [automation?.actions, automation?.did, automation?.tid, ensureTemplate]);
  useEffect(() => {
    const fetchData = async () => {
      if (automation?.tid) {
        try {
          const response = await axios.get(apiUrl(`template/get/${automation.template_id}`));
          const templateData = response.data?.data ?? null;
          setSelectedTemplate(templateData);
          console.log(templateData);
        } catch (error) {
          console.error("Error fetching template:", error);
        }
      }
    };

    fetchData();
  }, [automation?.tid, automation.template_id]);
  const currentTemplate = automation?.did ? templatesByDid[automation.did]
    : automation?.tid ? selectedTemplate : null;

  const dynamicFields = useMemo(
    () => buildTemplateFields(automation?.trigger, currentTemplate),
    [automation?.trigger, currentTemplate]
  );
  const conditionFields = useMemo(
    () => (
      automation.trigger === 'deviceStatus' ? statusFixedField :
        dynamicFields.length > 0 ? [...dynamicFields] : fixedField),
    [dynamicFields, automation.trigger]
  );
  const valueEditorWithDynamicFields = useCallback(
    (props) => (
      <CustomValueEditor
        {...props}
        dynamicFields={dynamicFields}
        trigger={automation.trigger}
        templatesByDid={templatesByDid}
      />
    ),
    [dynamicFields, templatesByDid, automation.trigger]
  );
  const triggerSelectOptions = useMemo(
    () => triggerOptions.map((option) => ({ value: option, label: option })),
    []
  );
  const deviceSelectOptions = useMemo(
    () => devices.map((device) => buildDeviceDropdownOption(device, 'did')),
    [devices]
  );
  const templateSelectOptions = useMemo(
    () =>
      templates.map((template) => ({
        value: template.tid,
        label: `${template.name} (${template.tid})`,
        tid: template.tid,
        template_id: template._row_id,
        name: template.name,
      })),
    [templates]
  );
  const selectedTriggerOption = triggerSelectOptions.find((option) => option.value === automation?.trigger) || null;
  const selectedDeviceOption = resolveDeviceOption(deviceSelectOptions, automation);
  const shouldShowDeviceSelect = Boolean(
    automation?.organization_id &&
    automation?.trigger !== 'manual' &&
    automation?.trigger !== 'schedule'
  );
  const shouldShowConditions =
    automation?.trigger === 'schedule' ||
    (automation?.trigger !== 'manual' && automation?.trigger !== 'schedule' && (Boolean(automation?.did) || Boolean(automation?.tid)));
  const handleTargetTypeChange = (event) => {
    const value = event.target.value;

    setTargetType(value);

    setAutomation((current) => ({
      ...current,
      did: null,
      device_id: null,
      device_name: null,
      tid: null,
      template_id: null,
      template_name: null,
      conditions: createEmptyConditions(),
    }));
  };
  const handleTemplateChange = (selectedOption) => {
    setAutomation((current) => ({
      ...current,
      tid: selectedOption?.tid || null,
      template_id: selectedOption?.template_id || null,
      template_name: selectedOption?.name || null,
      did: null,
      device_id: null,
      device_name: null,
      conditions: createEmptyConditions(),
    }));
  };
  const handleDescriptionChange = (event) => {
    const nextDescription = event.target.value;
    setAutomation((current) => ({
      ...current,
      description: nextDescription,
    }));
  };
  const conditionsRef = useRef(automation.conditions);
  const handleQueryChange = (query) => {
    setAutomation((current) => ({
      ...current,
      conditions: query,
    }));
  };
  const handleTriggerChange = (selectedOption) => {
    const nextTrigger = selectedOption ? selectedOption.value : null;

    setAutomation((current) => ({
      ...current,
      trigger: nextTrigger,
      device_id: nextTrigger === 'manual' || nextTrigger === 'schedule' ? null : current.device_id,
      did: nextTrigger === 'manual' || nextTrigger === 'schedule' ? null : current.did,
      device_name: nextTrigger === 'manual' || nextTrigger === 'schedule' ? null : current.device_name,
      conditions: createEmptyConditions(),
    }));
  };

  const handleTriggerDeviceChange = (selectedOption) => {
    const nextDid = selectedOption?.value ?? null;

    setAutomation((current) => ({
      ...current,
      device_id: getDeviceDropdownId(selectedOption),
      device_name: selectedOption?.name || selectedOption?.baseLabel || null,
      did: nextDid,
      conditions: createEmptyConditions(),
    }));
  };

  const handleSave = async () => {
    const normalizedConditions = normalizeConditions(automation.conditions, conditionFields);
    const preparedAutomation = {
      ...automation,
      conditions: applyConditionFieldTypes(normalizedConditions, conditionFields),
    };

    const payload = buildAutomationPayload(
      preparedAutomation,
      isCreateMode
        ? undefined
        : {
          persistedConditionIds: persistedIds.conditionIds,
          persistedActionIds: persistedIds.actionIds,
        }
    );

    setSubmitting(true);

    try {
      if (isCreateMode) {
        await axios.post(apiUrl(`automation`), payload, {
          headers: { 'Content-Type': 'application/json' },
        });

        showAlert('success', t.createSuccess || 'Automation created successfully.');
      } else {
        const response = await axios.put(apiUrl(`automation`), payload, {
          headers: { 'Content-Type': 'application/json' },
        });

        showAlert('success', response.data?.message || t.updateSuccess || 'Automation updated successfully.');
      }

      setTimeout(() => {
        navigate('/automations');
      }, 1600);
    } catch (error) {
      showAlert('error', getErrorMessage(error));
    } finally {
      setSubmitting(false);
    }
  };
  const normalizeConditions = (conditions, fields = []) => {
    if (!conditions) return conditions;
    const inputTypeByField = new Map(
      (Array.isArray(fields) ? fields : []).map((field) => [field.name, field.inputType])
    );

    const walk = (node) => {
      if (!node) return node;

      if (node.rules) {
        return {
          ...node,
          rules: node.rules.map(walk),
        };
      }

      if (node.value && typeof node.value === 'object') {
        const inputType = inputTypeByField.get(node.field) || node.inputType;
        const shouldForceDurationZero = isDateLikeConditionType(inputType);
        return {
          ...node,
          value: node.value.value ?? null,
          datastream_value: node.value.datastream_value ?? null,
          duration: shouldForceDurationZero ? 0 : node.value.duration ?? 0,
        };
      }

      if (isDateLikeConditionType(inputTypeByField.get(node.field) || node.inputType)) {
        return {
          ...node,
          duration: 0,
        };
      }

      return node;
    };

    return walk(conditions);
  };
  const hydrateConditions = (conditions) => {
    if (!conditions) return conditions;

    const walk = (node) => {
      if (!node) return node;

      if (node.rules) {
        return {
          ...node,
          rules: node.rules.map(walk),
        };
      }

      return {
        ...node,
        value: {
          value: node.value ?? '',
          datastream_value: node.datastream_value ?? '',
          duration: node.duration ?? 0,
        }
      };
    };

    return walk(conditions);
  };
  const isSaveDisabled =
    submitting ||
    !Array.isArray(automation?.actions) ||
    automation.actions.length === 0 ||
    !String(automation?.description ?? '').trim() ||
    (shouldShowDeviceSelect && (!automation?.did && !automation?.tid));

  if (!hasPermission) {
    return (
      <div className='configuration'>
        <div className='config-header'>
          <h2>Permission Denied</h2>
        </div>
        <div className='auto-permission-pad'>
          <p>
            {isCreateMode
              ? 'You do not have the required permission to create new automations.'
              : 'You do not have the required permission to edit automations.'}
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return <Spinner />;
  }


  return (
    <div className='configuration devices-page auto-page' dir={isRtl ? 'rtl' : 'ltr'}>
      <Alert
        open={alertState.open}
        close={() => setAlertState((current) => ({ ...current, open: false }))}
        message={alertState.message}
        type={alertState.type}
        position={alertState.position}
      />

      <div className='device-main'>
        <div className='automation-builder-card auto-builder-card'>
          <div className='automation-builder-header auto-builder-header'>
            <div className='automation-builder-header-left auto-builder-header-left'>
              <div className='auto-builder-header-badge'>
                <AutomationHeaderIcon />
              </div>
              <div>
                <h2 className='auto-builder-title'>
                  {isCreateMode ? t.headerNew || t.buttonNew : t.headerEdit}
                </h2>
                <p className='auto-builder-subtitle'>
                  {t.headerSubtitle || 'Define triggers and actions to automate your IoT workflows'}
                </p>
              </div>
            </div>

            <div className='automation-builder-header-right auto-builder-header-right'>
              <button
                type='button'
                onClick={() => navigate('/automations')}
                className='auto-builder-back'
              >
                {t.buttonBack || 'Back'}
              </button>

              <button
                className={`devices-primary-btn edit-btn-save auto-builder-save ${isSaveDisabled ? 'disabled' : ''}`}
                onClick={handleSave}
                disabled={isSaveDisabled}
              >
                <SettingsSuggestIcon />
                <span>{isCreateMode ? t.buttonCreate : t.buttonSave}</span>
              </button>
            </div>
          </div>

          <div className='auto-builder-divider' />

          <div className='auto-builder-body'>
            <div className='automation-fields auto-builder-fields'>
              <div>
                <div className='edit-form-item auto-form-item'>
                  <label className='auto-form-label auto-form-label--withicon'>
                    <span className='auto-label-icon'>
                      <TriggerIcon />
                    </span>
                    <span>{t.labelTrigger}</span>
                  </label>
                  <Select
                    id='trigger'
                    options={triggerSelectOptions}
                    value={selectedTriggerOption}
                    onChange={handleTriggerChange}
                    classNamePrefix='react-select'
                  />
                </div>

                <div className='edit-form-item auto-form-item auto-form-item--spaced'>
                  <label className='auto-form-label'>
                    <span className='auto-label-icon'>
                      <OrganizationIcon />
                    </span>
                    <span>{t.labelOrganization}</span>
                  </label>
                  <label className='edit-form-input' name='myInput'>
                    {automation.organization_name ?? ''}
                  </label>
                </div>

                {shouldShowDeviceSelect ? (
                  <div className='edit-form-item auto-form-item auto-form-item--spaced'>
                    <label className='auto-form-label'>Trigger Target</label>

                    <div
                      style={{
                        display: 'flex',
                        gap: 30,
                        marginInlineStart: 10,
                        marginTop: 12,
                        alignItems: 'center',
                      }}
                    >
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                          cursor: 'pointer',
                          fontSize: 15,
                          fontWeight: 500,
                        }}
                      >
                        <input
                          type='radio'
                          name='targetType'
                          value='device'
                          checked={targetType === 'device'}
                          onChange={handleTargetTypeChange}
                          style={{
                            transform: 'scale(1.3)',
                            cursor: 'pointer',
                          }}
                        />
                        <span>By Device</span>
                      </label>
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                          cursor: 'pointer',
                          fontSize: 15,
                          fontWeight: 500,
                        }}
                      >
                        <input
                          type='radio'
                          name='targetType'
                          value='template'
                          checked={targetType === 'template'}
                          onChange={handleTargetTypeChange}
                          style={{
                            transform: 'scale(1.3)',
                            cursor: 'pointer',
                          }}
                        />
                        <span>By Template</span>
                      </label>
                    </div>
                  </div>
                ) : null}
                {shouldShowDeviceSelect && targetType === 'device' ? (
                  <div className='edit-form-item auto-form-item auto-form-item--spaced'>
                    <label className='auto-form-label'>
                      <span className='auto-label-icon'>
                        <DeviceIcon />
                      </span>
                      <span>{t.labelDevice}</span>
                    </label>
                    <Select
                      id='devices'
                      options={deviceSelectOptions}
                      value={selectedDeviceOption}
                      onChange={handleTriggerDeviceChange}
                      classNamePrefix='react-select'
                    />
                  </div>
                ) : null}
                {shouldShowDeviceSelect && targetType === 'template' ? (
                  <div className='edit-form-item auto-form-item auto-form-item--spaced'>
                    <label className='auto-form-label'>
                      <span>{t.labelTemplate || 'Template'}</span>
                    </label>

                    <Select
                      options={templateSelectOptions}
                      value={
                        templateSelectOptions.find(
                          (option) => option.tid === automation?.tid
                        ) || null
                      }
                      onChange={handleTemplateChange}
                      classNamePrefix='react-select'
                    />
                  </div>
                ) : null}
              </div>

              <div className='edit-form-item auto-form-item'>
                <label className='auto-form-label'>{t.labelDescription}</label>
                <textarea
                  className='edit-form-input auto-desc-textarea'
                  name='automation-description'
                  value={automation.description ?? ''}
                  onChange={handleDescriptionChange}
                  placeholder={t.placeholderDescription}
                />
              </div>
            </div>

            {shouldShowConditions ? (
              <Fragment>
                <h3 className='qb-title'>{t.sectionConditions}</h3>

                <div className='qb-wrap'>
                  <QueryBuilder
                    fields={conditionFields}
                    query={automation.conditions}
                    onQueryChange={handleQueryChange}
                    showCloneButtons
                    // showLockButtons
                    controlClassnames={{
                      queryBuilder: 'qb-root queryBuilder-branches justifiedLayout',
                      ruleGroup: 'qb-group',
                      header: 'qb-groupHeader',
                      body: 'qb-groupBody',
                      combinators: 'qb-select qb-select--combinator',
                      addRule: 'qb-btn qb-btn--add',
                      addGroup: 'qb-btn qb-btn--add',
                      cloneGroup: 'qb-btn qb-btn--icon',
                      lockGroup: 'qb-btn qb-btn--icon',
                      removeGroup: 'qb-btn qb-btn--danger qb-btn--icon',
                      rule: 'qb-rule',
                      field: 'qb-select qb-select--field',
                      operator: 'qb-select qb-select--operator',
                      value: 'qb-value',
                      valueSource: 'qb-select qb-select--source',
                      cloneRule: 'qb-btn qb-btn--icon',
                      lockRule: 'qb-btn qb-btn--icon',
                      removeRule: 'qb-btn qb-btn--danger qb-btn--icon',
                    }}
                    controlElements={{
                      valueEditor: valueEditorWithDynamicFields
                    }}
                  />
                </div>
              </Fragment>
            ) : null}

            <h3 className='auto-actions-title'>
              <span className='auto-label-icon'>
                <ActionsIcon />
              </span>
              <span>{t.sectionActions}</span>
            </h3>
            <AutomationActionsBuilder
              devices={devices}
              selectedOptionDataStreams={automation.did ? templatesByDid[automation.did]?.datastreams : selectedTemplate?.datastreams}
              actions={automation.actions ?? []}
              trigger={automation.trigger ?? []}
              tid={automation.tid}
              setActions={(actions) => setAutomation((current) => ({ ...current, actions }))}
              templatesByDid={templatesByDid}
              templates={templates}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomationBuilderPage;
